<template>
  <div>
    <v-card>
      <v-card-title>
        <h2>Nova Função</h2>
      </v-card-title>

        <v-card-text>
            <v-flex xs12>
              <v-text-field v-model="occupation.description" label="Descrição*" box autofocus></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="occupation.cbo" label="Código CBO*" box></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-textarea v-model="occupation.observation" label="Observações" box no-resize></v-textarea>
            </v-flex>
            <v-divider></v-divider>
             <v-checkbox label="Incluir esta Função na Convenção"  v-model="checkbox"></v-checkbox>
          </v-card-text>

          <span class="blue--text pa-3">Os campos marcados com o (*) são obrigatórios</span><br><br>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" dark @click="cancel();">Cancelar</v-btn>
            <v-btn color="blue darken-1" dark @click="save();">Salvar</v-btn>
          </v-card-actions>
      </v-card>

      <v-dialog v-model="showDialogSetConventionItem" max-width="500">
        <form-set-convention-item :year-convention-selected="yearConventionSelected" :occupation-selected="occupationSaved"></form-set-convention-item>
      </v-dialog>
  </div>
</template>

<script>
// SERVICES //

// COMPONENTS //
import FormSetConventionItem from "../../components/budget/FormSetConventionItem";

export default {
  components: {
    FormSetConventionItem
  },

  props: {
    yearConventionSelected: {}
  },

  data: () => ({
    occupation: {},
    occupationSaved: "",
    checkbox: false,
    showDialogSetConventionItem: false,
  }), //data()

  methods: {
    init() {
      this.occupation = {};
      this.checkbox = false;
      this.showDialogSetConventionItem = false;
    }, //init()
    async save() {
      try {
        await this.$eventHub.$emit("savedNewOccupation");

        if (this.checkbox) {
          this.occupationSaved = this.occupation.data.description;
          this.yearConventionSelected = await this.yearConventionSelected;
          this.showDialogSetConventionItem = true;
        }
      } catch (error) {}
    }, //save()

    cancel() {
      this.init();
      this.$eventHub.$emit("cancelDialogAddNewOccupation");
    } //cancel()
  }, //methods

  created() {
    this.init();

    let thiss = this;

    thiss.$eventHub.$on("cancelDialogSetConventionItem", _ => {
      this.init();
      thiss.showDialogSetConventionItem = false;
    });
  } //created
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/budget/FormProfessionalCategory.vue